import React from 'react';
import BeneficiarySection from '../BeneficiarySection';
import BeneficiarySingleValue from '../BeneficiaryValues/BeneficiarySingleValue';
import { MainCategoryProps } from '../MainCategory';
import { getBeneficiaryIcon } from '../BeneficiaryMainCard';
import {
  Beneficiaries,
  BeneficiaryTitleInfoProps,
} from '../utils/beneficiaryInterfaces';
import { beneficiaryTitle } from '../utils/helperComponents';

const minWidth = 256;

interface BeneficiaryGenderProps extends BeneficiaryTitleInfoProps {
  beneficiary: Beneficiaries['gender'];
  setBeneficiaries: MainCategoryProps['setBeneficiaries'];
}

const BeneficiaryGender: React.FC<BeneficiaryGenderProps> = ({
  beneficiary,
  beneficiaryLabel,
  programName,
  setBeneficiaries,
}) => {
  if (beneficiary === undefined) return null;
  return (
    <BeneficiarySection
      icon={getBeneficiaryIcon('gender')}
      setBeneficiaries={setBeneficiaries}
      category="gender"
      heading="Gender and sexual identity"
      title={beneficiaryTitle(
        'the Gender and sexual identity',
        programName,
        beneficiaryLabel,
      )}
      note={undefined}
    >
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Women and girls"
        buttonLabel="Women and girls"
        inputLabel="Females"
        categoryName="gender"
        category={beneficiary.categories}
        fieldName="Females"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Men and boys"
        buttonLabel="Men and boys"
        inputLabel="Males"
        categoryName="gender"
        category={beneficiary.categories}
        fieldName="Males"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="LGBTQIA+ people"
        buttonLabel="LGBTQIA+ people"
        inputLabel="LGBTQIA+ people"
        categoryName="gender"
        category={beneficiary.categories}
        fieldName="LGBTQ"
        setBeneficiaries={setBeneficiaries}
      />
    </BeneficiarySection>
  );
};

export default React.memo(BeneficiaryGender);
